import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { MwProgressBarService } from '@core/services';
import { MwHttpService } from '@core/http';
import { MwCompanyService } from '@core/auth/services/company.service';

import { AutoLoginApiResult } from './app-modules.models';

@Injectable()
export class MwAppModulesApiService {
  constructor(
    private http: MwHttpService,
    private companyService: MwCompanyService,
    private progressBarService: MwProgressBarService
  ) {}

  getAutoLoginLink(url: string): Observable<AutoLoginApiResult> {
    this.progressBarService.show();
    return this.http
      .authPost<AutoLoginApiResult>('/integration/v1/autoLogin/generateLink', {
        body: {
          companyId: this.companyService.instantActiveCompanyId,
          url,
        },
      })
      .pipe(tap(() => this.progressBarService.hide()));
  }
}
